<template>
  <div>
    <template v-for="(comment, index) in displayCommentList">
      <v-card v-if="isComment" :key="index + '-commentBody'" flat>
        <v-card-text>
          <v-layout
            row
            wrap
            class="pl-0"
            :class="{
              'pr-1': $vuetify.breakpoint.smAndUp,
              'pr-0': $vuetify.breakpoint.xsOnly
            }"
          >
            <v-flex pl-2 xs12 sm12 md9 lg9 xl10>
              <v-flex xs12 class="d-inline-flex">
                <v-flex>
                  <vc-share-avatar-image
                    :size="32"
                    :src="comment.userImagePath"
                  >
                  </vc-share-avatar-image>
                </v-flex>
                <v-flex class="d-inline-flex">
                  <v-flex align-self-center>
                    <v-avatar tile size="20">
                      <img :src="serviceTypeIcon(comment.accountProvider)" />
                    </v-avatar>
                  </v-flex>
                  <v-flex align-self-center>
                    {{ comment.userDisplayName }}
                  </v-flex>
                  <v-flex align-self-center>
                    <span class="grey--text"> {{ comment.postedTime }} </span>
                  </v-flex>
                </v-flex>
              </v-flex>
              <v-flex
                xs12
                align-self-start
                :class="[$style.textWordWrap, 'pt-0']"
              >
                <span class="d-inline-block" style="vertical-align: top;">
                  {{ comment.comment }}
                </span>
              </v-flex>
            </v-flex>
            <v-flex xs12 sm12 md3 lg3 xl2 class="text-xs-right">
              <v-flex xs12 class="d-inline-flex">
                <vc-share-button
                  :twitter-text="comment.twitterText"
                  :twitter-hash-tags="comment.twitterHashTags"
                  :line-text="comment.lineText"
                  :src-url="comment.commentUrl"
                  :lang="lang.ShareIcons"
                  :show-japanese-web-site="showJapaneseWebSite"
                ></vc-share-button>
                <connect-vc-share-comment-menu-button
                  :comment-id="comment.commentId"
                  :posted-comment-user="
                    postedCommentUser(comment.accountProvider, comment.userId)
                  "
                  :lang="lang.CommentMenuButton"
                  :clip-is-logged-in="clipIsLoggedIn"
                  :clip-login-url="clipLoginUrl"
                  :validation-lang="validationLang"
                  :locale-code="localeCode"
                ></connect-vc-share-comment-menu-button>
                <connect-vc-share-comment-report-button
                  :comment-id="comment.commentId"
                  :posted-comment-user="
                    postedCommentUser(comment.accountProvider, comment.userId)
                  "
                  :lang="lang.CommentMenuButton"
                  :clip-is-logged-in="clipIsLoggedIn"
                  :clip-login-url="clipLoginUrl"
                  :validation-lang="validationLang"
                  :locale-code="localeCode"
                  :mail-link="mailLink"
                  :privacy-url="privacyUrl"
                ></connect-vc-share-comment-report-button>
              </v-flex>
              <v-flex
                v-if="
                  locale !== comment.postedOriginalLocale &&
                    comment.isTranslated
                "
                xs12
                class="text-xs-right pt-2"
              >
                <connect-vc-share-comment-translation-button
                  :lang="lang.ContentsTranslationButton"
                  :comment-id="comment.commentId"
                >
                </connect-vc-share-comment-translation-button>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-divider
        v-if="
          isComment &&
            Number(index) !== Object.keys(displayCommentList).length - 1
        "
        :key="index + '-separatorLine'"
      >
      </v-divider>
    </template>
    <template v-if="isComment && !moreCommentsFlag && FourOrMoreContents">
      <v-divider></v-divider>
      <v-card flat>
        <v-card-text class="py-2">
          <v-layout justify-center>
            <v-flex class="text-xs-center">
              <v-btn :class="$style.btnTextStyle" large @click="moreComments()">
                {{ lang.CommentList.more_comments }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>

<script>
export default {
  name: "vc-share-comment-list",
  props: {
    contentsId: {
      type: Number,
      default: 0
    },
    clipUserId: {
      type: Number,
      default: 0
    },
    twitterUserId: {
      type: Number,
      default: 0
    },
    facebookUserId: {
      type: Number,
      default: 0
    },
    locale: {
      type: String,
      default: ""
    },
    lang: {
      type: Object,
      default: () => {
        return {
          CommentList: {
            first_comment: "最初のコメントをしましょう！",
            more_comments: "コメントをもっと見る"
          },
          CommentMenuButton: {},
          ContentsTranslationButton: {},
          ShareIcons: {}
        };
      }
    },
    clipIsLoggedIn: {
      type: Boolean,
      default: false
    },
    clipLoginUrl: {
      type: String,
      default: ""
    },
    validationLang: {
      type: Object,
      default: () => {
        return {
          required: "",
          max: {
            string: ""
          }
        };
      }
    },
    localeCode: {
      type: String,
      default: ""
    },
    displayCommentList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    identificationCode: {
      type: String,
      default: ""
    },
    getCommentList: {
      type: Function,
      default: () => {}
    },
    moreComments: {
      type: Function,
      default: () => {}
    },
    originalCommentList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    moreCommentsFlag: {
      type: Boolean,
      default: false
    },
    mailLink: {
      type: String,
      default: ""
    },
    privacyUrl: {
      type: String,
      default: "#"
    }
  },
  data: function() {
    return {
      isComment: false,
      FourOrMoreContents: false,
      commentLocale: "ja-jp",
      clipIconSrc: require("./assets/celsys_official.png"),
      twitterIconSrc: require("./assets/ph_sns_x.png"),
      facebookIconSrc: require("./assets/ph_sns_fb.png"),
      translatedGoogleImage: require("./assets/translated_by_google_grayscale.png"),
      translatedGoogleIconImage: require("./assets/google_logo.png"),
      defaultUserPictureUrl: require("./assets/ico_noimage.gif"),
      showJapaneseWebSite: true
    };
  },
  created: function() {
    this.getCommentList(this.identificationCode);
  },
  mounted: function() {
    if (this.locale !== "ja-jp") {
      this.showJapaneseWebSite = false;
    }
  },
  methods: {
    serviceTypeIcon: function(key) {
      switch (key) {
        case "clip":
          return this.clipIconSrc;
        case "twitter":
          return this.twitterIconSrc;
        case "facebook":
          return this.facebookIconSrc;
      }
    },
    postedCommentUser: function(key, value) {
      switch (key) {
        case "clip":
          return this.clipUserId === value;
        case "twitter":
          return this.twitterUserId === value;
        case "facebook":
          return this.facebookUserId === value;
      }
    },
    altSrc: function(value) {
      this.displayCommentList[value].userImagePath = this.defaultUserPictureUrl;
    }
  },
  watch: {
    displayCommentList: function() {
      this.isComment = Object.keys(this.displayCommentList).length !== 0;
    },
    originalCommentList: function() {
      this.FourOrMoreContents = this.originalCommentList.length > 3;
    }
  }
};
</script>

<style module>
.textWordWrap {
  word-wrap: break-word;
  word-break: break-all;
}

.btnTextStyle {
  text-transform: none !important;
}
</style>
